module.exports = __webpack_public_path__ + "static/pepsi_Page_1-a47d3557e3c09d36c0dcd235969be859.jpg";